/**
 * A ABA EM SESSÃO DE SUPORTE (ou do olhinho do console): o link trocado fica em
 * sessionStorage, que uma aba nova aberta com `noopener` NÃO herda — ela cairia no
 * login normal de quem está olhando, noutro workspace (28/10: "Nenhuma entidade
 * chamada appointment"). Quem abre aba nova pergunta isto antes.
 */
export const SUPPORT_KEY = "bx_support_link";

export function inSupportTab(): boolean {
	try {
		return Boolean(sessionStorage.getItem(SUPPORT_KEY));
	} catch {
		return false;
	}
}
